export const priceListPagePath = '/price-list';